export enum GameChildishIconMode {    
    UseDefaultIcon,
    UseNonChildishIcon,
    PreferNonChildishIcon
}
